<template>
  <div class="dropdown" :class="{'active': dropdown}" @click="dropdown = !dropdown">
    <div class="dropdown-front">
      {{ computedValue }}
      <img :class="{'active': dropdown}" :src="getImage('blue-down-arrow.svg')">
    </div>
    <ul class="dropdown-content">
      <li v-if="!required"
          @click="$emit('change', null, null, null, null)"
        >{{ $t('general.makeYourChoice') }}.</li>
      <li class="option"
          v-for="option in options"
          :class="option.recommended ? 'recommended' : ''"
          @click="$emit('change', option.key, option.length, option.width, option.height)"
          v-text="option.value"
      ></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Dropdown",

  data() {
    return {
      dropdown: false,
      // value: 'value',
    }
  },

  props: {
    options: {
      required: true,
      type: Array,
      validator: function (options) {
        // Option has to be an array with objects with key value pairs
        for (const option of options) {
          // not shorthand ! otherwise 0 key or value is gonna fail
          if (option['key'] === undefined || option['value'] === undefined) {
            return false;
          }
        }

        return true;
      }
    },

    value: {
      required: true,
    },

    required: {
      type: Boolean,
      default: true,
    }
  },

  computed: {
    computedValue() {
      for (const option of this.options) {
        if (option.key === this.value) {
          return option.value;
        }
      }

      return this.$t('general.makeYourChoice');
    }
  },

  methods: {
    clickOut(e) {
      // close dropdown when clicked outside
      if (!this.$el.contains(e.target)) {
        this.dropdown = false
      }
    }
  },

  created: function () {
    window.addEventListener('click', this.clickOut);
  },

  beforeDestroy() {
    window.removeEventListener('click', this.clickOut);
  }
}
</script>

<style scoped lang="scss">
.dropdown {
  border-radius: 50px;
  border: 2px solid #EBEBEB;
  height: 40px;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  width: 100%;
  position: relative;
  background-color: white;
  cursor: pointer;
  user-select: none;
  transition: all ease 0.3s;

  &:focus, :active {
    outline: none;
    box-shadow: none;
    border-color: #EBEBEB;
  }

  &.active {
    .dropdown-content {
      transition: all ease 0.3s;
      transform: translateY(0);
      opacity: 1;
      z-index: 1000;
    }
  }
}

.dropdown-front {
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  img {
    transition: all ease 0.3s;
    transform: rotate(90deg);

    &.active {
      transform: rotate(0deg);
    }
  }
}

.dropdown-content {
  list-style: none;
  padding: 0;
  position: absolute;
  top: 37px;
  right: 0;
  left: 0;
  transform: translateY(-20px);
  opacity: 0;
  z-index: -1;
  background-color: white;
  max-width: 236px;
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #EBEBEB;
  box-shadow: 4px 4px 8px 1px #AFAFAF;
  transition: all ease 0.3s;
  max-height: 400px;
  overflow: auto;

  li {
    color: #212529;
    padding: 3px 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;

    &.recommended {
      color: #71BC03;

      &:after {
        content: " Aanbevolen";
        position: absolute;
        left: 65%;
      }
    }

    &:hover {
      width: 100%;
      background-color: #3DB0C7;
      color: white;
      border-radius: 5px;
    }

    &:nth-child(odd) {
      background-color: #F1F1F1;

      &:hover {
        background-color: #3DB0C7;
      }

    }

  }
}

</style>
